export const ENTER_KEY_CODE = 13;
export const ARROW_UP_KEY_CODE = 38;
export const ARROW_DOWN_KEY_CODE = 40;
export const ESCAPE_KEY = 27;

export default {};
